export default "/images/vendor/@coreui/icons/svg/flag/cif-mx.svg?03a6aa3f6d4e96fa145878f56bf20fad";